import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<CreateOptions @poll={{@model}} />",{ moduleName: "@croodle/client/templates/create/options.hbs" })